<ng-content></ng-content>
<form>
  <div class="input-field">
    <input required type="text" #simulationAddress id="simulationAddress" name="simulationAddress" />
    <label for="simulationAddress">Uw volledig adres</label>
  </div>
  <button type="submit" [disabled]="buttonDisabled" (click)="distanceCalculator(simulationAddress)"
    class="btn waves-effect waves-light">
    Doe een simulatie
  </button>
</form>
@if (showAlert) {
  <div class="alert">
    <a class="close waves-effect waves-light btn-flat" (click)="removeAlert()">
      <svg class="icon">
        <use xlink:href="assets/sprites.svg#times"></use>
      </svg>
    </a>
    @if (showSimulation | async) {
      <div class="info">
          <ul>
            <li>Jouw woonplaats is het kortste bij onze <strong>consultatieruimte in {{ results[0].region }}</strong></li>
            <li>Afstand tot {{ simulationAddress.value }}: {{ results[0].distance | number: '1.1-1' }}km</li>
            <li>Reiskostenvergoeding voor zorg aan huis: <strong>{{ results[0].cost  | currency: 'EUR':'symbol-narrow':'1.2-2' }}</strong></li>
          </ul>
          <ul>
            <li>Indien je een voorkeur hebt voor begeleiding door vroedvrouw(en) in <strong>{{ results[1].region }}</strong></li>
            <li>Afstand tot {{ simulationAddress.value }}: {{ results[1].distance | number: '1.1-1' }}km</li>
            <li>Reiskostenvergoeding voor zorg aan huis:  {{ results[1].cost  | currency: 'EUR':'symbol-narrow':'1.2-2' }}</li>
          </ul>
        @if (results[0].cost > 0 || results[1].cost > 0) {
          <div>
            In sommige gevallen is er een tegemoetkoming van het ziekenfonds of andere verzekeraar
            mogelijk voor reiskosten:
            <ul class="browser-default">
              <li>Bij prenatale zittingen van een risicozwangerschap (doktersattest vereist).</li>
              <li>Sommige hospitalisatieverzekeringen komen hierin tegemoet. Dit kan u navragen bij uw verzekeraar.</li>
            </ul>
          </div>
        }
      </div>
    }
    @if (showError) {
      <div class="error">
        Simulatie naar adres <strong>{{ simulationAddress.value }}</strong> is niet gelukt.
        Probeer uw adres zo volledig mogelijk te noteren. <br />
        Lukt het nog niet? Contacteer ons vrijblijvend op het telefoonnummer
        <a href="tel:+32460230233">0460 230 233</a>.
      </div>
    }
  </div>
}